import React, {createContext, useContext, useState} from 'react';
import {toast} from 'react-hot-toast';
import useLocalStorage from '../hooks/useLocalStorage';
import lang from "../JSON-FILES/lang.json"

const Context = createContext();

/**
 *  #context
 * The OfflineContext component provides a context for managing offline data.
 * It includes error states from useLocalStorage, a flag to track pending operations,
 * and a wrapper function to handle offline data updates safely.
 *
 * The OfflineContext component provides the following values to its children:
 * - offlineData: The current offline data stored in local storage
 * - setOfflineData: A direct setter for updating the offline data in local storage
 * - base64Images: The current base64 images stored in local storage
 * - setBase64Images: A direct setter for updating the base64 images in local storage
 * - offlineError: An error state for the offline data in local storage
 * - imagesError: An error state for the base64 images in local storage
 * - bypassOffline: A flag to bypass the offline data update mechanism
 * - setBypassOffline: A direct setter for updating the bypassOffline flag
 * - failedDevicesQueryDocs: The current failed devices query docs stored in local storage
 * - setFailedDevicesQueryDocs: A direct setter for updating the failed devices query docs in local storage
 * - isPending: A flag to track whether an offline data update is in progress
 */
export const OfflineContext = ({children}) => {
    // Include error states from useLocalStorage
    const [offlineData, setOfflineData, offlineError] = useLocalStorage("offlineData");
    const [failedDevicesQueryDocs, setFailedDevicesQueryDocs, failedDevicesQueryDocsError] = useLocalStorage("failedDevicesQueryDocs");
    const [base64Images, setBase64Images, imagesError] = useLocalStorage("base64Images");
    const [bypassOffline, setBypassOffline] = useLocalStorage("bypassOffline");
    
    // Track pending operations
    const [isPending, setIsPending] = useState(false);

    // Wrapper function to handle offline data updates safely
/*     const updateOfflineData = async (newData) => {
        if (isPending) {
            toast.error('Another update is in progress. Please wait.');
            return false;
        }

        try {
            setIsPending(true);

            // Ensure data is always an array
            const dataToStore = Array.isArray(newData) ? newData : [];
            
            // Store the data
            setOfflineData(dataToStore);

            toast.success('Changes saved offline');
            return true;
        } catch (err) {
            console.error('Error updating offline data:', err);
            toast.error(`Failed to save changes: ${err.message}`);
            return false;
        } finally {
            setIsPending(false);
        }
    }; */

    return (
        <Context.Provider
            value={{
                offlineData, 
                setOfflineData, // Direct setter for persistence
                //updateOfflineData, // Wrapper function with validation
                base64Images, 
                setBase64Images,
                offlineError,
                imagesError,
                bypassOffline, 
                setBypassOffline,
                failedDevicesQueryDocs, 
                setFailedDevicesQueryDocs,
                isPending
            }}>
            {children}
        </Context.Provider>
    )
}

export const useOfflineContext = () => useContext(Context);
